import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'ImSearchableSelectController',
            ImSearchableSelectController
        );

    function ImSearchableSelectController(
        $scope,
        $timeout,
        LocalStorageService,
        NextFactory
    ) {
        var vm = this;
        var canDownload = true;

        init();

        function init() {
            vm.placeholderText = vm.placeholderText || 'Szukaj';
            vm.getDataFromApi = getDataFromApi;
            vm.selectItem = selectItem;
            vm.disableFocus = disableFocus;
            vm.clearOnSelect = vm.clearOnSelect || false;

            getScrollBoxHeight();
        }

        function getDataFromApi(params, search) {
            params = params || {};
            search = vm.alternativeSearchName || 'search';
            params[search] = vm.search;
            vm.selectedObject = null;

            if (params[search].length > 0) {
                vm.apiFunction(
                    LocalStorageService.getObject('common/company').organization
                        .party_uuid,
                    params
                ).then(function (response) {
                    vm.dataFromBackend = response.data;

                    if (
                        response.data.results.length === 1 &&
                        params[search] === response.data.results[0].address
                    ) {
                        selectItem(response.data.results[0]);
                        disableFocus();
                    }
                });
            } else {
                vm.dataFromBackend = null;
            }
        }

        function getNext(api) {
            canDownload = false;
            NextFactory.read(api).then(function (response) {
                vm.dataFromBackend.next = response.data.next;
                vm.dataFromBackend.results = vm.dataFromBackend.results.concat(
                    response.data.results
                );
                canDownload = true;
            });
        }

        function selectItem(item) {
            vm.selectedObject = item;
            if (vm.clearOnSelect) {
                vm.search = '';
                vm.dataFromBackend = null;
            } else {
                vm.search = item[vm.apiDisplay];
            }
        }

        function disableFocus() {
            $timeout(function () {
                vm.focused = false;
            }, 300);
        }

        function getScrollBoxHeight() {
            $scope.$watchGroup(
                [
                    function () {
                        return vm.focused;
                    },
                    function () {
                        return vm.dataFromBackend;
                    },
                ],
                function () {
                    if (vm.focused && vm.dataFromBackend) {
                        var scrollBox = angular.element(
                            document.querySelector('.searchable-select-results')
                        );
                        scrollBox.bind('scroll', function () {
                            if (
                                scrollBox.scrollTop() +
                                    scrollBox[0].clientHeight >
                                scrollBox[0].scrollHeight - 100
                            ) {
                                if (vm.dataFromBackend.next && canDownload) {
                                    $scope.$apply(function () {
                                        getNext(vm.dataFromBackend.next);
                                    });
                                }
                            }
                        });
                    }
                }
            );
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/filters/searchable-select/searchable-select.controller.ts